<template>
    <b-button @click="addFile" size="sm" :variant="variant"  :title="showToolTip ? tooltip : ''">
      <i :class="icon"></i>{{ text === null ? '' : ' ' + text }}
      <input ref="uploader" class="d-none" type="file" :accept="accept" @change="onFileChanged"/>
    </b-button>
</template>

<script>

export default ({
  name: "button-add-file",

  props: {    
    variant: {
      type: String,
      default: 'warning'
    },
    tooltip: {
      type: String,
      default: 'Добавить файл'
    },
    icon: {
      type: String,
      default: "fa fa-plus"
    },
    accept: {
      type: String,
      default: "image/*;capture=camera"
    },
    text: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
  },

  data: function() {
    return {
      isSelecting: false,
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
  
  methods: {
    addFile() {
      this.isSelecting = true;

      window.addEventListener('focus', () => {
          this.isSelecting = false
      }, { once: true })

      this.$refs.uploader.value = null
      this.$refs.uploader.click()
    },

    onFileChanged(e) {
      this.$emit('onAddFile', e.target.files[0])

    }
  }
})
</script>
